export default __webpack_public_path__ + "static/media/8.6e9ae6e4.png";